// Level-2 kinds capture copy (10/18). Drafted by Astra (copy lane, GPT-6 Astra via the astra skill, brief and raw output in
// the 10/18 laptop session), gated by Claude 10/18/26: names at most 18 characters, no dashes or exclamation marks, no
// "listings", no AI words; the card eyebrow uses a short form where the full name would repeat its category (two gate
// rounds back to Astra: "Music · Electronic music", then "Art · Street" and "Market · Night" did not stand alone).
// Do not edit by hand: a line that needs to change goes back to Astra. (10/24, B-216: kinds.taste_sub rewritten by Astra
// after the section began showing liked kinds too.)
export const KINDS_COPY: Record<string, string> = {
  "kinds.chips_label": "More of these",
  "kinds.chips_aria": "Tell us which kinds you want more of",
  "kinds.chip_on": "{kind}, added to your taste",
  "kinds.ask": "More {kind}?",
  "kinds.yes": "Yes, more",
  "kinds.no": "Less, please",
  "kinds.close": "Close",
  "kinds.taste_title": "Kinds you like",
  "kinds.taste_sub": "Kinds you’ve liked, plus nearby options matching your interests. Tap unticked kinds for more."
}

/** A kind's name on chips and in "More {kind}?" (slug from pipeline/vocab.json subs). */
export const KIND_NAMES: Record<string, string> = {
  "jazz": "Jazz",
  "rock-indie": "Rock / indie",
  "punk-metal": "Punk / metal",
  "electronic": "Electronic music",
  "hip-hop-rnb": "Hip-hop / R&B",
  "folk-country": "Folk / country",
  "classical-opera": "Classical / opera",
  "latin": "Latin music",
  "experimental": "Experimental music",
  "singer-songwriter": "Singer-songwriters",
  "open-jam": "Open jams",
  "drag-cabaret": "Drag / cabaret",
  "trivia-games": "Trivia / games",
  "stand-up": "Stand-up",
  "improv": "Improv",
  "sketch": "Sketch comedy",
  "storytelling": "Storytelling",
  "musical-theater": "Musical theater",
  "new-plays": "New plays",
  "gallery-opening": "Gallery openings",
  "museum-show": "Museum shows",
  "street-art": "Street art",
  "design-architecture": "Design / buildings",
  "photography": "Photography",
  "repertory-film": "Film revivals",
  "indie-film": "Indie films",
  "documentary": "Documentaries",
  "ceramics": "Ceramics",
  "drawing-painting": "Drawing / painting",
  "crafts-textiles": "Crafts / textiles",
  "cooking-class": "Cooking classes",
  "dance-class": "Dance classes",
  "language-exchange": "Language exchanges",
  "book-club": "Book clubs",
  "run-club": "Run clubs",
  "volunteering": "Volunteering",
  "workshop-panel": "Workshops / panels",
  "lecture-author-talk": "Lectures / talks",
  "hike": "Hikes",
  "beach": "Beach days",
  "gardens": "Gardens",
  "birding": "Birding",
  "bike-ride": "Bike rides",
  "stargazing": "Stargazing",
  "climbing": "Climbing",
  "team-sports": "Team sports",
  "yoga-wellness": "Yoga / wellness",
  "farmers-market": "Farmers markets",
  "flea-vintage": "Flea / vintage",
  "makers-market": "Makers markets",
  "night-market": "Night markets",
  "food-festival": "Food festivals"
}

/** The card eyebrow ("Music · Jazz"): a short form only where the full name repeats its category or reads oddly after it. */
export const KIND_EYEBROW: Record<string, string> = {
  "electronic": "Electronic",
  "latin": "Latin",
  "experimental": "Experimental",
  "sketch": "Sketch",
  "musical-theater": "Musicals",
  "street-art": "Murals",
  "cooking-class": "Cooking",
  "dance-class": "Dance",
  "farmers-market": "Farmers market",
  "makers-market": "Makers market",
  "night-market": "Night market",
  "food-festival": "Festivals"
}

const PROPER = new Set(['latin']) // keeps its capital inside a sentence

/** Full name (chips); `inSentence` lowercases the first letter for "More {kind}?" unless it is a proper noun. */
export function kindName(slug: string, inSentence = false): string {
  const n = KIND_NAMES[slug] ?? (slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, ' '))
  return inSentence && !PROPER.has(slug) ? n.charAt(0).toLowerCase() + n.slice(1) : n
}
/** The eyebrow form after the category. */
export const kindEyebrow = (slug: string): string => KIND_EYEBROW[slug] ?? kindName(slug)

export function kc(key: string, vars: Record<string, string> = {}): string {
  let s = KINDS_COPY[key] ?? key
  for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, v)
  return s
}
